export default __webpack_public_path__ + "static/media/a011-fsi-04.fe14a754.svg";